import { createRoute } from "@tanstack/react-router";
import { PaidDashboard } from "@/components/marketing/paid-dashboard";
import { PageHeader } from "@/components/shared/page-header";
import { BRAND_LABELS, type Brand } from "@/lib/marketing/constants";
import { Route as authenticatedRoute } from "../_authenticated";

function MarketingPaidPage() {
  const { brand } = Route.useParams();
  const b = brand as Brand;
  return (
    <div className="space-y-6">
      <PageHeader
        title={`${BRAND_LABELS[b] ?? brand} — Paid Ads`}
        description="Ad spend and results vs. benchmarks. Green = on track, yellow = watch, red = needs attention."
      />
      <PaidDashboard brand={b} />
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/marketing/paid/$brand",
  component: MarketingPaidPage,
});
